/**
 * Footer - Pied de page avec liens légaux et sources officielles
 * Conforme au CDC Juridique v1.2 §9.5
 * Note: Aucun lien CGV ni mention tarifaire (gelés)
 */
import { Link } from 'react-router-dom'

export default function Footer() {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="bg-white border-t border-gray-200 mt-auto print:hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Grille des sections */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Section Légal */}
          <div>
            <h4 className="text-sm font-semibold text-gray-900 mb-4">
              Légal
            </h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/mentions-legales"
                  className="text-sm text-gray-600 hover:text-gray-900 hover:underline"
                >
                  Mentions légales
                </Link>
              </li>
              <li>
                <Link
                  to="/cgu"
                  className="text-sm text-gray-600 hover:text-gray-900 hover:underline"
                >
                  CGU
                </Link>
              </li>
              <li>
                <Link
                  to="/confidentialite"
                  className="text-sm text-gray-600 hover:text-gray-900 hover:underline"
                >
                  Confidentialité
                </Link>
              </li>
              <li>
                <Link
                  to="/cookies"
                  className="text-sm text-gray-600 hover:text-gray-900 hover:underline"
                >
                  Cookies
                </Link>
              </li>
            </ul>
          </div>

          {/* Section Sources officielles */}
          <div>
            <h4 className="text-sm font-semibold text-gray-900 mb-4">
              Sources officielles
            </h4>
            <ul className="space-y-2">
              <li>
                <a
                  href="https://www.inrs.fr"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-gray-600 hover:text-gray-900 hover:underline inline-flex items-center gap-1"
                >
                  INRS
                  <svg
                    className="w-3 h-3"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                    />
                  </svg>
                </a>
              </li>
              <li>
                <a
                  href="https://www.anses.fr"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-gray-600 hover:text-gray-900 hover:underline inline-flex items-center gap-1"
                >
                  ANSES
                  <svg
                    className="w-3 h-3"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                    />
                  </svg>
                </a>
              </li>
              <li>
                <a
                  href="https://echa.europa.eu"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-gray-600 hover:text-gray-900 hover:underline inline-flex items-center gap-1"
                >
                  ECHA
                  <svg
                    className="w-3 h-3"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                    />
                  </svg>
                </a>
              </li>
              <li>
                <a
                  href="https://www.agritox.anses.fr"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-gray-600 hover:text-gray-900 hover:underline inline-flex items-center gap-1"
                >
                  AGRITOX
                  <svg
                    className="w-3 h-3"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                    />
                  </svg>
                </a>
              </li>
            </ul>
          </div>

          {/* Section À propos */}
          <div>
            <h4 className="text-sm font-semibold text-gray-900 mb-4">
              À propos
            </h4>
            <p className="text-sm text-gray-600 leading-relaxed">
              RISK-DATA est un outil d'aide à la recherche toxicologique
              destiné aux professionnels de la prévention des risques chimiques.
            </p>
          </div>
        </div>

        {/* Copyright */}
        <div className="pt-6 border-t border-gray-200">
          <p className="text-xs text-gray-500 text-center">
            © {currentYear} [À COMPLÉTER] — Tous droits réservés
          </p>
        </div>
      </div>
    </footer>
  )
}
